import { render, staticRenderFns } from "./BaseInputNumber.vue?vue&type=template&id=4ec6f95e&scoped=true&"
import script from "./BaseInputNumber.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseInputNumber.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseInputNumber.vue?vue&type=style&index=0&id=4ec6f95e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec6f95e",
  null
  
)

export default component.exports